export function compareDate(dateTime) {
  const millSec = new Date(dateTime).getTime();

  return {
    isBefore: function (compareDateTime) {
      if (!millSec) {
        return true
      }
      
      const compareMillSec = new Date(compareDateTime).getTime();

      if (millSec < compareMillSec) {
        return true;
      } else {
        return false;
      }
    },
  };
}
export function localeToUTC(time) {
  const dateTime = new Date(time.replace(/-/g, "/"));
  const year = dateTime.getUTCFullYear()
  const month = dateTime.getUTCMonth() + 1 < 10 ? `0${dateTime.getUTCMonth() + 1}` : dateTime.getUTCMonth() + 1;
  let date = dateTime.getUTCDate() < 10 ? `0${dateTime.getUTCDate()}` : dateTime.getUTCDate();
  let hour = dateTime.getUTCHours() < 10 ? `0${dateTime.getUTCHours()}` : dateTime.getUTCHours();
  let minute = dateTime.getUTCMinutes() < 10 ? `0${dateTime.getUTCMinutes()}` : dateTime.getUTCMinutes();
  let second = dateTime.getUTCSeconds() < 10 ? `0${dateTime.getUTCSeconds()}` : dateTime.getUTCSeconds();

  return `${year}/${month}/${date} ${hour}:${minute}:${second}`;
}
export function UTCTimeToLocale(time, isHideSeconds, separator){
  let t = UTCTimeFormat(time);
  return convertUTCToLocale(t, isHideSeconds, separator);
}
export function UTCTimeFormat(time){
  if(time.indexOf('T')!== -1)return time;
  //
  const words = time.split(':')
  let hasSecond = words.length === 3;
  //let hasMiniSecond = time.indexOf('.') !== -1;

  //if(time.)
  //"2019-08-10T02:37:54.770Z"
  let _time = time.replace(' ', 'T');
  !hasSecond && (_time += ':00')
  _time += 'Z'
  return _time;
}

export function convertUTCToLocale(utcTimeString, isHideSeconds, separator) {
  let dateToHandle = new Date(utcTimeString);
  let year = dateToHandle.getFullYear();
  let month = dateToHandle.getMonth() + 1 < 10 ? `0${dateToHandle.getMonth() + 1}` : dateToHandle.getMonth() + 1;
  let date = dateToHandle.getDate() < 10 ? `0${dateToHandle.getDate()}` : dateToHandle.getDate();
  let hours = dateToHandle.getHours() < 10 ? `0${dateToHandle.getHours()}` : dateToHandle.getHours();
  let minutes = dateToHandle.getMinutes() < 10 ? `0${dateToHandle.getMinutes()}` : dateToHandle.getMinutes();
  let seconds = dateToHandle.getSeconds() < 10 ? `0${dateToHandle.getSeconds()}` : dateToHandle.getSeconds();
  
  if (!separator || separator !== '-') {
    separator = '/'
  } else {
    separator = '-'
  }
  if(isHideSeconds){
    return `${year}${separator}${month}${separator}${date} ${hours}:${minutes}`;
  }

  return `${year}${separator}${month}${separator}${date} ${hours}:${minutes}:${seconds}`;
}